export const checkActive = (expanded, buttonIndex, index) =>
  (!expanded || buttonIndex === -1) || (expanded && buttonIndex === index)
export const findActiveExpander = (children, index, buttonActive) =>
  [...Array((children || []).length)].map((val, key) =>
    key === index ? buttonActive[key] === undefined || !buttonActive[key] : false
  )
export const checkSeparator = (menuLength, index, title) => menuLength - 1 !== index && title
